import {
  AssetApi,
  AssetFileApi,
  Configuration,
} from '@galleryjs/api-digital-assets'
import { useAuth } from '@praxis/component-auth'
import { useEnv } from '@praxis/component-runtime-env'
import { GwtEnv } from '../customTypes'

// Our hook
export default function useGalleryApis() {
  const auth = useAuth()
  const env = useEnv<GwtEnv>()

  const apiBaseUrl = env.baseGalleryApiUrl?.toString()
  const accessToken = auth.session?.accessToken

  const config: Configuration = new Configuration({
    accessToken,
    basePath: apiBaseUrl,
  })
  // Set up clients.
  const assetClient = new AssetApi(config)
  const fileClient = new AssetFileApi(config)

  return {
    assetClient,
    fileClient,
  }
}
